import CollapsedCard from './CollpasedCard';
import RowCard from './RowCard';
import { CostLabel } from './Amount';
import { BarTarget } from './ActionBar';
import { ScoreTrack, TablePortrait } from './TableBoards';

// The key of a tactic in play as the action bar's Tactic button picks it (copying it): by its name, as copies of a
// tactic are one, except a card that has gained strength (Sun Tzu), which is its own (see the engine's ActionBar.js)
const TacticKey = (tactic) => `tactic:${tactic.bonus > 0 ? tactic.card.id : tactic.card.name}`;

// The military board, under the card row beside the culture board (TableBoards.js), for everyone, with "Use new UI" (else
// MilitaryArea, on each board): each civilization's military strength on a track, players tied on a space in the order
// the rules break the tie (from the current player in turn order), the one who wins it rightmost, as ahead. Beside it
// the tactics someone is on (or Sun Tzu went under), as full cards with the markers of those on them along the bottom.
// They have room kept for one a player, so a tactic played or given up moves nothing, and the track has the rest. Under
// the track, the tactics no one is on, small (as in hand). They stay in the order they came into play, so playing one
// moves nothing. Last, Pierre de Coubertin's Olympic Games while they last (Olympics: the game's olympics, with the name
// of the player whose next turn ends them).
// CubeColors: each player's cubes' color. Bar: the action bar, while its Tactic button picks a tactic to copy here.
// Current: the player whose turn it is
function MilitaryBoard({Military, CubeColors, Bar, GameEngine, Olympics, Current})
{
    // (a tactic in play, with static buttons and no trigger on: what copying it costs, and why it can't be copied)
    const handOf = (tactic) => !Bar?.active ? Bar?.hand?.[TacticKey(tactic)] : null;
    if (!Military)
    {
        return null;
    }
    const active = Military.tactics.filter(tactic => tactic.players.length > 0 || tactic.bonus > 0);
    const unused = Military.tactics.filter(tactic => !active.includes(tactic));
    return (
        <div className="tta tta-left tta-military-area tta-table-board" style={{ '--slots': Military.ranking.length }}>
            {/* At the left the track, and under it the tactics no one is on; then the tactics in use */}
            <div className="tta-military-main">
                <div className="tta-military-top">
                    {/* (strongest first, so reversed: the stronger of those tied after the others on their space) */}
                    <ScoreTrack Title="Military strength" Icon="Strength" Colors={CubeColors} step={5} Current={Current}
                        Markers={[...Military.ranking].reverse().map(entry => ({ player: entry.player, name: entry.name, value: entry.strength, breakdown: entry.breakdown }))}/>
                </div>
                {unused.length > 0 &&
                    <div className="tta-military-tactics">
                        {unused.map(tactic =>
                            <BarTarget key={tactic.card.id ?? tactic.card.name} Bar={Bar} TargetKey={TacticKey(tactic)} GameEngine={GameEngine}>
                                {/* (with static buttons and no trigger on: clicked to copy it, why not in its hover) */}
                                <CollapsedCard card={tactic.card} Cost={handOf(tactic)?.cost} Usable={handOf(tactic)?.selectable} Note={handOf(tactic)?.reason}/>
                            </BarTarget>)}
                    </div>}
            </div>
            <div className="tta-military-active">
                {active.map(tactic =>
                    <BarTarget key={tactic.card.id ?? tactic.card.name} Bar={Bar} TargetKey={TacticKey(tactic)} GameEngine={GameEngine}>
                        <div className="tta-military-tactic">
                            {/* (with static buttons and no trigger on: clicked to copy it, why not in its hover) */}
                            <RowCard card={tactic.card} title={handOf(tactic)?.reason}/>
                            {/* Who is on it (how many armies that player's units form for it: in the tooltip) */}
                            <div className="tta-tactic-markers">
                                {tactic.players.map(player =>
                                    <span key={player} className="tta-tactic-marker-wrap" title={`On this tactic${tactic.armies?.[player] ? `: ${tactic.armies[player]} arm${tactic.armies[player] === 1 ? 'y' : 'ies'}` : ''}`}>
                                        <span className="tta-tactic-marker" style={{ backgroundColor: CubeColors[player] }}/>
                                    </span>)}
                            </div>
                            {/* (what copying it costs, faded when it can't be) */}
                            {handOf(tactic)?.cost &&
                                <span className={`tta-hand-cost tta-tactic-cost${handOf(tactic).selectable ? '' : ' off'}`}><CostLabel cost={handOf(tactic).cost}/></span>}
                        </div>
                    </BarTarget>)}
            </div>
            {Olympics && <TablePortrait Image="Coubertin" Card={Olympics.card}
                Effect={`Olympic Games, until ${Olympics.name}'s next turn: a war or aggression costs 8 culture`}/>}
        </div>
    );
}

export default MilitaryBoard;
